import { useCallback, useEffect, useRef } from 'react';

export const useIntersectObserver = (
  onIntersect: (entry: IntersectionObserverEntry, observer: IntersectionObserver) => void,
  options?: IntersectionObserverInit,
) => {
  const observerRef = useRef<IntersectionObserver | null>(null);

  const callback: IntersectionObserverCallback = useCallback(
    (entries, observer) => {
      entries.forEach((entry) => onIntersect(entry, observer));
    },
    [onIntersect],
  );

  useEffect(() => {
    observerRef.current = new IntersectionObserver(callback, options);

    return () => {
      observerRef.current?.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const observe = (element: Element) => {
    observerRef.current?.observe(element);
  };

  const unobserve = (element: Element) => {
    observerRef.current?.unobserve(element);
  };

  return { observe, unobserve };
};
